import React from 'react';
import { css } from 'emotion';
import { RadioGroup, Radio } from '@guardian/src-radio';
import { FieldLabel } from './FieldLabel';
export const RadioSelect = ({ formField, formData, setFormData, }) => (
// work around to enforce `display: flex;` to `RadioGroup`'s fieldset tag
// https://github.com/guardian/source/issues/580
React.createElement("div", { className: css `
			fieldset {
				display: flex;
			}
		` },
    React.createElement(FieldLabel, { formField: formField }),
    React.createElement(RadioGroup, { name: formField.name, orientation: formField.options.length > 2 ? 'vertical' : 'horizontal' }, formField.options.map((option, index) => {
        const isRadioChecked = formField.id in formData &&
            formData[formField.id] === option.value;
        return (React.createElement(Radio, { "data-testid": `form-field-${option.value}`, key: index, label: option.label, value: option.value, name: `${formField.id}`, checked: !!isRadioChecked, onClick: () => setFormData({
                ...formData,
                [formField.id]: option.value,
            }) }));
    }))));
